import React from "react";
import { motion } from "framer-motion";
import { EyeIcon, WindIcon, SunIcon, HeartIcon, BoxIcon } from "lucide-react";
import { benefits, natureImage } from "../data/content";
const icons: Record<string, BoxIcon> = {
  eye: EyeIcon,
  wind: WindIcon,
  sun: SunIcon,
  heart: HeartIcon
};
export function Benefits() {
  return <section id="beneficios" className="w-full bg-cream py-20 sm:py-28" aria-labelledby="beneficios-title" data-id="element-9" data-mp="3vpxnc19f6dh9">
      <div className="mx-auto max-w-6xl px-6 lg:px-8" data-id="element-10" data-mp="3qt75b8e217t7">
        <div className="max-w-xl" data-id="element-11" data-mp="3mpiywt15si9j">
          <p className="font-sans text-xs uppercase tracking-[0.28em] text-gold-deep" data-id="element-12" data-mp="3mp93ur19bkwz">
            Qué vas a lograr
          </p>
          <h2 id="beneficios-title" className="mt-5 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-13" data-mp="3ht21f882krjs">
            No se trata de no sentir miedo. Se trata de caminar con él.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-3xl bg-ink/10 sm:grid-cols-2" data-id="element-14" data-mp="1b0hznf5hz4vu">
          {benefits.map((benefit, i) => {
          const Icon = icons[benefit.icon];
          return <motion.article key={benefit.title} initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.07
          }} className="bg-ivory p-8 sm:p-10" data-id="element-15" data-mp="6st922wv0hzh" data-mpi={i}>
                <Icon className="h-6 w-6 text-gold-deep" strokeWidth={1.5} aria-hidden="true" data-id="element-16" data-mp="liqptxsgm5en" />
                <h3 className="mt-5 font-serif text-2xl text-ink" data-id="element-17" data-mp="qfqwoax4vc6t">
                  {benefit.title}
                </h3>
                <p className="mt-3 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-18" data-mp="brct1xrw7jp7">
                  {benefit.text}
                </p>
              </motion.article>;
        })}
        </div>

        <figure className="mt-16 overflow-hidden rounded-3xl" data-id="element-19" data-mp="14eyylbkokyep">
          <img src={natureImage} alt="Hierbas altas iluminadas por la luz dorada del atardecer" className="h-48 w-full object-cover sm:h-64" loading="lazy" data-id="element-20" data-mp="197rz1n949kkz" />
        </figure>
      </div>
    </section>;
}